export default __webpack_public_path__ + "static/media/hot-12.5ee8bf92.png";